import {Injectable} from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class SEOService {

  constructor(
    private title: Title,
    private meta: Meta,
    private router: Router
  ) { }

  baseUrl = "https://leonelifestyle.com";
  currentUrl = this.baseUrl + this.router.url;
  assetsPath = this.baseUrl + "/assets/";
  desc = "Per essere artefici del cambiamento e del benessere";
  shareImg = this.assetsPath;

  updatePageTags(pageTitle?: string, desc?: string, shareImg?: string){
    this.title.setTitle(pageTitle);

    let siteDesc = this.desc;
    if (desc) {
      siteDesc = desc;
    } else {
      siteDesc = this.desc;
    }

    this.meta.updateTag({ name: 'description', content: siteDesc })
    this.meta.updateTag({ property: 'og:description', content: siteDesc })

    this.meta.updateTag({ property: 'og:title', content: pageTitle })
    this.meta.updateTag({ property: 'og:image', content: this.shareImg + shareImg })
    this.meta.updateTag({ property: 'og:image:alt', content: pageTitle })
    this.meta.updateTag({ property: 'og:url', content: this.currentUrl })
  }
}